var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWhite = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#white_svg__clip0_1210_18321)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "white_svg__a",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 40,
  height: 41
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M20 40C8.954 40 0 31.047 0 20 0 8.955 8.954 0 20 0s20 8.954 20 20-8.954 20-20 20z",
  fill: "#fff"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#white_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M.001 0h40v40h-40V0z",
  fill: "url(#white_svg__paint0_linear_1210_18321)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.001 0h40v40h-40V0z",
  fill: "#3321A4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.001 0h40v40h-40V0z",
  fill: "url(#white_svg__paint1_radial_1210_18321)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.001 0h40v40h-40V0z",
  fill: "url(#white_svg__paint2_radial_1210_18321)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.105 1.515C26.93 19.601 9.713 40.472 3.86 40.058 57.415 49.287 41.617 13.636 44.234-.01H8.685c-.776 0-1.14.986-.58 1.524z",
  fill: "url(#white_svg__paint3_linear_1210_18321)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.546 17.085c1.05 22.623-20.865 29.216-26.795 28.829 36.775 8.173 60.351-17.346 62.97-29.92H26.56c-.583 0-1.04.51-1.013 1.091z",
  fill: "url(#white_svg__paint4_linear_1210_18321)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.546 17.085c1.05 22.623-20.865 29.216-26.795 28.829 36.775 8.173 60.351-17.346 62.97-29.92H26.56c-.583 0-1.04.51-1.013 1.091z",
  fill: "url(#white_svg__paint5_linear_1210_18321)"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "white_svg__paint0_linear_1210_18321",
  x1: 36.557,
  y1: 5.392,
  x2: 4.746,
  y2: 35.738,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#1E2837"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#364459"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "white_svg__paint3_linear_1210_18321",
  x1: 40.144,
  y1: 41.601,
  x2: 21.925,
  y2: -9.407,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#7300FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B98CFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "white_svg__paint4_linear_1210_18321",
  x1: 37.149,
  y1: 16.345,
  x2: 49.597,
  y2: 47.314,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#3DD0FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.912,
  stopColor: "#364AFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "white_svg__paint5_linear_1210_18321",
  x1: 37.149,
  y1: 16.345,
  x2: 49.597,
  y2: 47.314,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00D7DC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.912,
  stopColor: "#4B3CFF"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "white_svg__paint1_radial_1210_18321",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "matrix(-40.0003 0 0 -20.0001 39.887 19.859)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#2D1E8B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3321A4"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "white_svg__paint2_radial_1210_18321",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "rotate(-179.843 24.473 9.963) scale(49.0312 24.5155)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#0F0073"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2D00BE"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "white_svg__clip0_1210_18321"
}, /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  rx: 20,
  fill: "#fff"
})))));
export default "data:image/svg+xml;base64,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";
export { SvgWhite as ReactComponent };